import React, { useContext, useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import { ToolBarContext } from '../../../App';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import useMainSpeaker from '../../../hooks/useMainSpeaker/useMainSpeaker';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fab: {
      margin: theme.spacing(1),
    },
    disabled: {
      margin: theme.spacing(1),
      backgroundColor: 'gray',
      pointerEvents: 'none',
    },
  })
);

export default function ToggleAnnotateButton() {
  const classes = useStyles();

  const { setToolbarEnabled, toolbarEnabled } = useContext(ToolBarContext);
  const {
    sendDataToParticipants,
    hasMainVideo,
    room: { localParticipant },
  } = useVideoContext();
  const mainParticipant = useMainSpeaker();
  const toolbarStatus = toolbarEnabled ? 'Close' : 'Open';
  const [initialLoad, setInitialLoad] = useState(true);

  const handleToolbarButtonClick = () => {
    if (hasMainVideo) setToolbarEnabled(!toolbarEnabled);
  };

  useEffect(() => {
    if (toolbarEnabled) {
      sendDataToParticipants(
        JSON.stringify({
          type: 'ANNOTATION_START',
          data: {
            isSketchActive: toolbarEnabled,
            currentUserOnSketchField: mainParticipant,
            currentHostForSketch: localParticipant,
          },
        })
      );
    } else {
      sendDataToParticipants(
        JSON.stringify({
          type: 'ANNOTATION_STOP',
          data: {
            isSketchActive: toolbarEnabled,
          },
        })
      );
    }
  }, [toolbarEnabled]);

  useEffect(() => {
    if (!initialLoad) setToolbarEnabled(false);
    else setInitialLoad(!initialLoad);
  }, [mainParticipant]);

  //No annotation when main video is not present
  useEffect(() => {
    if (!hasMainVideo) setToolbarEnabled(false);
  }, [hasMainVideo]);

  return (
    <Tooltip
      title={hasMainVideo ? `${toolbarStatus} Toolbar` : `No Video Source to Annotate`}
      color="primary"
      onClick={handleToolbarButtonClick}
      placement="top"
      PopperProps={{ disablePortal: true }}
      style={{ cursor: !hasMainVideo ? 'not-allowed' : 'pointer' }}
    >
      <div>
        <Fab className={hasMainVideo ? classes.fab : classes.disabled}>
          <BorderColorIcon />
        </Fab>
      </div>
    </Tooltip>
  );
}
